import {
    MEMO_REMINDER_UPDATE_REQUEST,
    MEMO_REMINDER_UPDATE_SUCCESS,
    MEMO_REMINDER_UPDATE_FAILURE
} from "../../../constants"

const initialState = {
    data: null,
    loading: false,
    error: null,
    type: null,
};

const arvReminderUpdaterReducer = (state = initialState, action) => {
    switch (action.type) {
        case MEMO_REMINDER_UPDATE_REQUEST:
            return {
                ...state,
                loading: true,
                data: null,
                error: null,
                type: action.types,
            };
        case MEMO_REMINDER_UPDATE_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                type: action.types,
                error: null,
            };
        case MEMO_REMINDER_UPDATE_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                type: action.types,
                data: null,
            };
        default:
            return state;
    }
};

export default arvReminderUpdaterReducer;
